'use strict';

const stopwords = ['αλλ(α|ά)',
	'αν',
	'αντ(ι|ί)',
	'απ(ο|ό)',
	'αυτ(α|ά)',
	'αυτ(ε|έ)ς',
	'αυτ(η|ή)',
	'αυτ(ο|ό)',
	'αυτο(ι|ί)',
	'αυτ(ο|ό)ς',
	'αυτο(υ|ύ)ς',
	'αυτ(ω|ώ)ν',
	'αἱ',
	'αἳ',
	'αἵ',
	'αὐτός',
	'αὐτὸς',
	'αὖ',
	'γάρ',
	'γα',
	'γα^',
	'γε',
	'για',
	'γοῦν',
	'γὰρ',
	'"δ"',
	'δέ',
	'δή',
	'δαί',
	'δαίς',
	'δαὶ',
	'δαὶς',
	'δε',
	'δεν',
	'"δι"',
	'διά',
	'διὰ',
	'δὲ',
	'δὴ',
	'δ’',
	'ε(α|ά)ν',
	'ε(ι|ί)μαι',
	'ε(ι|ί)μαστε',
	'ε(ι|ί)ναι',
	'ε(ι|ί)σαι',
	'ε(ι|ί)στε',
	'εκε(ι|ί)να',
	'εκε(ι|ί)νες',
	'εκε(ι|ί)νη',
	'εκε(ι|ί)νο',
	'εκε(ι|ί)νοι',
	'εκε(ι|ί)νος',
	'εκε(ι|ί)νους',
	'εκε(ι|ί)νων',
	'εν(ω|ώ)',
	'επ',
	'επ(ι|ί)',
	'εἰ',
	'εἰμί',
	'εἰμὶ',
	'εἰς',
	'εἰς',
	'εἴ',
	'εἴμι',
	'εἴτε',
	'η',
	'θα',
	'(ι|ί)σως',
	'κ',
	'καί',
	'καίτοι',
	'καθ',
	'και',
	'κατ',
	'κατά',
	'κατα',
	'κατὰ',
	'καὶ',
	'κι',
	'κἀν',
	'κἂν',
	'μέν',
	'μή',
	'μήτε',
	'μα',
	'με',
	'μεθ',
	'μετ',
	'μετά',
	'μετα',
	'μετὰ',
	'μη',
	'μην',
	'μἐν',
	'μὲν',
	'μὴ',
	'μὴν',
	'να',
	'ο',
	'οι',
	'(ο|ό)μως',
	'(ο|ό)πως',
	'(ο|ό)σο',
	'(ο|ό)τι',
	'οἱ',
	'οἳ',
	'οἷς',
	'οὐ',
	'οὐδ',
	'οὐδέ',
	'οὐδείς',
	'οὐδεὶς',
	'οὐδὲ',
	'οὐδὲν',
	'οὐκ',
	'οὐχ',
	'οὐχὶ',
	'οὓς',
	'οὔτε',
	'οὕτω',
	'οὕτως',
	'οὕτως',
	'οὖν',
	'οὗ',
	'οὗτος',
	'οὗτος',
	'παρ',
	'παρά',
	'παρα',
	'παρὰ',
	'περί',
	'περὶ',
	'ποι(α|ά)',
	'ποι(ε|έ)ς',
	'ποι(ο|ό)',
	'ποιο(ι|ί)',
	'ποι(ο|ό)ς',
	'ποιο(υ|ύ)ς',
	'ποι(ω|ώ)ν',
	'π(ο|ό)τε',
	'που',
	'ποῦ',
	'προ',
	'προς',
	'πρός',
	'πρὸ',
	'πρὸς',
	'πως',
	'πως',
	'σε',
	'στη',
	'στην',
	'στο',
	'στον',
	'σός',
	'σύ',
	'σύν',
	'σὸς',
	'σὺ',
	'σὺν',
	'τά',
	'τήν',
	'τί',
	'τίς',
	'τίς',
	'τα',
	'ταῖς',
	'τε',
	'την',
	'της',
	'τι',
	'τινα',
	'τις',
	'τις',
	'το',
	'τοί',
	'τοι',
	'τοιοῦτος',
	'τοιοῦτος',
	'τον',
	'τοτε',
	'του',
	'τούς',
	'τοὺς',
	'τοῖς',
	'τοῦ',
	'των',
	'τό',
	'τόν',
	'τότε',
	'τὰ',
	'τὰς',
	'τὴν',
	'τὸ',
	'τὸν',
	'τῆς',
	'τῆς',
	'τῇ',
	'τῶν',
	'τῷ',
	'ως',
	'"ἀλλ"',
	'ἀλλά',
	'ἀλλὰ',
	'ἀλλ’',
	'ἀπ',
	'ἀπό',
	'ἀπὸ',
	'ἀφ',
	'ἂν',
	'ἃ',
	'ἄλλος',
	'ἄλλος',
	'ἄν',
	'ἄρα',
	'ἅμα',
	'ἐάν',
	'ἐγώ',
	'ἐγὼ',
	'ἐκ',
	'ἐμός',
	'ἐμὸς',
	'ἐν',
	'ἐξ',
	'ἐπί',
	'ἐπεὶ',
	'ἐπὶ',
	'ἐστι',
	'ἐφ',
	'ἐὰν',
	'ἑαυτοῦ',
	'ἔτι',
	'ἡ',
	'ἢ',
	'ἣ',
	'ἤ',
	'ἥ',
	'ἧς',
	'ἵνα',
	'ὁ',
	'ὃ',
	'ὃν',
	'ὃς',
	'ὅ',
	'ὅδε',
	'ὅθεν',
	'ὅπερ',
	'ὅς',
	'ὅς',
	'ὅστις',
	'ὅστις',
	'ὅτε',
	'ὅτι',
	'ὑμός',
	'ὑπ',
	'ὑπέρ',
	'ὑπό',
	'ὑπὲρ',
	'ὑπὸ',
	'ὡς',
	'ὡς',
	'ὥς',
	'ὥστε',
	'ὦ',
	'ᾧ'
];

const stopWordsMap = [
	{
		find: '(?:^|(?<=\\s))(' + stopwords.join('|') + ')(?:(?=\\s)|$)',
		replace: ''
	}
];

module.exports = stopWordsMap;
